import React, {useState} from 'react';
import MarkdownInput from '../_ui/formElements/MarkdownInput';
import ReactMarkdown from 'react-markdown';

export function TicketTitleEditor({ticket, saving, onSave, onEditingChange}) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState('');
    const close = () => { setEditing(false); onEditingChange(false); };
    return editing ? <>
        <input aria-label="Ticket title" type="text" value={draft} disabled={saving}
            className="mx-3 px-3 flex-grow-1" onChange={event => setDraft(event.target.value)}/>
        <button className="btn btn-success btn-sm mt-1" disabled={saving || !draft.trim()}
            onClick={async () => { if (await onSave('title', draft)) close(); }}>Update Title</button>
        <button className="btn btn-danger btn-sm mt-1 ms-2" disabled={saving} onClick={close}>Cancel</button>
    </> : <>
        <span className="px-3 flex-grow-1">{ticket.title ? `${ticket.title} #${ticket.ticket_id}` : `Ticket #${ticket.ticket_id}`}</span>
        <button className="btn btn-success btn-sm mt-1 align-self-end" disabled={saving}
            onClick={() => { setDraft(ticket.title || ''); setEditing(true); onEditingChange(true); }}>Edit Title</button>
    </>;
}

export function TicketDescriptionEditor({ticket, type, saving, onSave, onEditingChange}) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState('');
    const close = () => { setEditing(false); onEditingChange(false); };
    return editing ? <>
        <MarkdownInput value={draft} changeHandler={setDraft} height="300px"/>
        <div className="d-flex justify-content-end">
            <button className="btn btn-success btn-sm mt-3 me-3" disabled={saving}
                onClick={async () => { if (await onSave('description', draft)) close(); }}>Update Description</button>
            <button className="btn btn-danger btn-sm mt-3" disabled={saving} onClick={close}>Cancel</button>
        </div>
    </> : <>
        <ReactMarkdown>{`${type?.name ? `**${type.name}** - ` : ''}${ticket.description || 'Click the Edit Description button to add a description.'}`}</ReactMarkdown>
        <div className="d-flex justify-content-end">
            <button className="btn btn-success btn-sm" disabled={saving}
                onClick={() => { setDraft(ticket.description || ''); setEditing(true); onEditingChange(true); }}>Edit Description</button>
        </div>
    </>;
}
